import { testIds } from '../testConfig.utils';

export const QA_MATCH_CENTRE_MATCH_STATS = {
  ...testIds('MATCH_CENTRE_MATCH_STATS', {}),
};

export const QA_MATCH_CENTRE_LINE_UPS = {
  ...testIds('MATCH_CENTRE_LINE_UPS', {}),
};

export const QA_MATCH_CENTRE_HEADER = {
  ...testIds('MATCH_CENTRE_HEADER', {}),
};

export const QA_MATCH_CENTRE_COMMENTARY = {
  ...testIds('MATCH_CENTRE_COMMENTARY', {}),
};

export const QA_MATCH_CENTRE_AROUND_THE_GROUNDS = {
  ...testIds('MATCH_CENTRE_AROUND_THE_GROUNDS', {}),
};

export const QA_MATCH_CENTRE_LEAGUE_TABLE = {
  ...testIds('MATCH_CENTRE_LEAGUE_TABLE', {}),
};
